import React from 'react';
import { flavorsUtils } from 'services/infra/modules/flavorsModule';

import { FieldCheckbox } from 'reactApp/components/Forms/FieldCheckbox';
import { FieldDependentValue } from 'reactApp/components/Forms/FieldDependentValue';
import { FieldInput } from 'reactApp/components/Forms/FieldInput';
import { QuestionTooltipHighCpu } from 'reactApp/components/Forms/FieldsAvailabilityZoneAndFlavor/QuestionTooltipHighCpu/QuestionTooltipHighCpu';
import { FieldSelect } from 'reactApp/components/Forms/FieldSelect';
import { FlavorSelect } from 'reactApp/components/Forms/FlavorSelect';
import { getIn } from 'reactApp/components/Forms/formUtils';

import { connectFormikContext } from '../ConnectFormikContext';
import css from './FieldsAvailabilityZoneByFlavor.css';

@connectFormikContext()
export class FieldsAvailabilityZoneByFlavor extends React.Component {
    static defaultProps = {
        name: 'name',
    };

    _generateFlavorId = (values) => {
        const {
            highCpuFlavors,
            minFlavor,
            cpuCheckboxFieldName,
            flavors,
        } = this.props;

        const cpuCheckboxFieldValue = getIn(values, cpuCheckboxFieldName);

        return flavorsUtils.generateFlavorId(
            highCpuFlavors,
            minFlavor,
            flavors,
            cpuCheckboxFieldValue,
        );
    };

    _generateAvailabilityZoneName = (values) => {
        const { availabilityZones, availabilityZoneFieldName } = this.props;
        const availabilityZoneFieldValue = getIn(
            values,
            availabilityZoneFieldName,
        );
        return flavorsUtils.generateAvailabilityZoneName(
            availabilityZones,
            availabilityZoneFieldValue,
        );
    };

    _generateAvailabilityZone = (values) => {
        const {
            flavorFieldName,
            availabilityZoneFieldName,
            flavors,
        } = this.props;
        const flavorFieldValue = getIn(values, flavorFieldName);
        const availabilityZoneFieldValue = getIn(
            values,
            availabilityZoneFieldName,
        );
        return flavorsUtils.generateAvailabilityZone(
            flavors,
            flavorFieldValue,
            availabilityZoneFieldValue,
        );
    };

    _getAvailabilityZoneDisabled(flavorId) {
        const availabilityZonesForFlavor = flavorsUtils.getAvailabilityZonesForFlavor(
            this.props.flavors,
            flavorId,
        );

        return (
            availabilityZonesForFlavor &&
            availabilityZonesForFlavor.length === 1
        );
    }

    render() {
        const {
            _formikContext,
            name,
            flavorLabel,
            flavorFieldName,
            cpuCheckboxFieldName,
            availabilityZones,
            availabilityZoneFieldName,
            highCpuFlavors,
            flavors,
            additionalFlavorsOptions,
            renderFlavorSelectField = true,
        } = this.props;

        const isAvailabilityZoneDisabled = this._getAvailabilityZoneDisabled(
            getIn(_formikContext.values, flavorFieldName),
        );
        const cpuCheckboxFieldValue = getIn(
            _formikContext.values,
            cpuCheckboxFieldName,
        );
        const standardCpuFlavors = flavorsUtils.getStandardCpuFlavors(flavors);

        return (
            <>
                {renderFlavorSelectField && (
                    <>
                        <FieldDependentValue
                            dataTest="select-flavor-type"
                            label={flavorLabel || 'Тип виртуальной машины'}
                            name={flavorFieldName}
                            fieldControl={FlavorSelect}
                            dependentFieldNames={[cpuCheckboxFieldName]}
                            flavors={
                                cpuCheckboxFieldValue
                                    ? highCpuFlavors
                                    : standardCpuFlavors
                            }
                            generateValue={this._generateFlavorId}
                            additionalOptions={additionalFlavorsOptions}
                        />

                        <FieldCheckbox
                            dataTest="checkbox-high-cpu"
                            controlLabel="Высокопроизводительные CPU"
                            name={cpuCheckboxFieldName}
                            wrapperClassName={css.highCpu}
                            disabled={!highCpuFlavors.length > 0}
                            extraLabel={<QuestionTooltipHighCpu />}
                        />
                    </>
                )}
                <FieldDependentValue
                    dataTest="select-zone"
                    label="Зона доступности"
                    name={availabilityZoneFieldName}
                    fieldControl={FieldSelect}
                    dependentFieldNames={[
                        cpuCheckboxFieldName,
                        flavorFieldName,
                    ]}
                    options={flavorsUtils.getAllAvailabilityZones(
                        availabilityZones,
                    )}
                    disabled={isAvailabilityZoneDisabled}
                    generateValue={this._generateAvailabilityZone}
                />

                <FieldDependentValue
                    name={name}
                    fieldControl={FieldInput}
                    hidden={true}
                    disabled={true}
                    dependentFieldNames={[availabilityZoneFieldName]}
                    generateValue={this._generateAvailabilityZoneName}
                />
            </>
        );
    }
}
